import { usePageTitleTranslation } from 'libs/navigation';

import { useAdmins } from '../hooks';
import { AdminsView } from '../views/AdminsView';

export const AdminsContainer = () => {
  const {
    admins,
    loading,
    sort,
    page,
    limit,
    rowCount,
    filter,
    setFilter,
    setRowHref,
    onSortChange,
    onPaginationChange,
  } = useAdmins();

  usePageTitleTranslation('admin.admins.pageTitle');

  return (
    <AdminsView
      admins={admins}
      limit={limit}
      loading={!admins?.length && loading}
      page={page}
      rowCount={rowCount}
      search={filter.search ?? ''}
      setRowHref={setRowHref}
      sort={sort}
      onPaginationChange={onPaginationChange}
      onSearch={(v) => setFilter({ search: v })}
      onSortChange={onSortChange}
    />
  );
};
